export interface TryOutHistoryEntry {
  id: string;
  createdAt: string;
  lastStatus?: string;
}

const MAX_ENTRIES = 50;

function key(slug: string): string {
  return `tryout-history-${slug}`;
}

export function loadHistory(slug: string): TryOutHistoryEntry[] {
  try {
    const raw = localStorage.getItem(key(slug));
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    return Array.isArray(parsed) ? (parsed as TryOutHistoryEntry[]) : [];
  } catch {
    return [];
  }
}

export function saveHistory(slug: string, entries: TryOutHistoryEntry[]): void {
  localStorage.setItem(key(slug), JSON.stringify(entries.slice(0, MAX_ENTRIES)));
}

export function prependHistory(slug: string, entry: TryOutHistoryEntry): void {
  const prev = loadHistory(slug).filter((e) => e.id !== entry.id);
  saveHistory(slug, [entry, ...prev]);
}

export function updateHistoryEntry(
  slug: string,
  id: string,
  patch: Partial<Pick<TryOutHistoryEntry, 'lastStatus'>>
): void {
  const prev = loadHistory(slug);
  const idx = prev.findIndex((e) => e.id === id);
  if (idx === -1) return;
  prev[idx] = { ...prev[idx], ...patch };
  saveHistory(slug, [...prev]);
}
